export default __webpack_public_path__ + "static/media/109.9f60c5ae.gif";